import React, { Component } from 'react';
import { connect } from 'react-redux';
import TopicsMenu from './TopicsMenu/TopicsMenu';
import SortingMenu from './SortingMenu/SortingMenu';
import SubtopicsMenu from './SubtopicsMenu/SubtopicsMenu';
import CategoryItemsList from './CategoryItemsList/CategoryItemsList';
import CategoryIntroVideo from './CategoryIntroVideo/CategoryIntroVideo';
import './CategoryPage.css';
import { fetchCategoryData, resetCategoryData, saveLastLocation } from '../../../redux/actions';
import { MAIN_SECTIONS, PATH } from '../../../constants';

class CategoryPage extends Component {
  componentDidMount() {
    this.fetchData();
  }

  componentDidUpdate(prevProps) {
    if (this.props.match.params.categoryId !== prevProps.match.params.categoryId) {
      this.fetchData();
      window.scrollTo(0, 0);
    }
  }

  componentWillUnmount() {
    this.props.resetCategoryData();
  }

  fetchData() {
    this.props.fetchCategoryData(this.props.match.params.categoryId);
    this.props.saveLastLocation(this.props.match.url);
  }

  render() {
    const { detailActive } = this.props;
    const { categoryId } = this.props.match.params;
    const categoryData = MAIN_SECTIONS[categoryId];
    return (
      <div>
        <img
          className="header-image"
          src={`${PATH.IMG}title/title-${categoryId}.png`}
          alt={categoryData.title}
        />
        <div className="category-top">
          <CategoryIntroVideo
            category={categoryId}
            detailActive={detailActive}
          />
          <TopicsMenu />
        </div>
        <SubtopicsMenu />
        <SortingMenu />
        <CategoryItemsList />
      </div>
    );
  }
}

const mapStateToProps = state => ({
  detailActive: state.dataDetail.active,
  category: state.dataDetail.category,
});

const mapDispatchToProps = dispatch => ({
  fetchCategoryData: categoryId => dispatch(fetchCategoryData(categoryId)),
  resetCategoryData: () => dispatch(resetCategoryData()),
  saveLastLocation: lastLocation => dispatch(saveLastLocation(lastLocation)),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(CategoryPage);



// WEBPACK FOOTER //
// ./src/components/App/CategoryPage/CategoryPage.js